import {
  TRACK_USER_ACTION_EVENT,
  trackUserAction,
} from '@/utilities/logger/amplitude/tracking';
import { JackpotTier } from '../types';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { WonJackpotData } from '../JackpotWinningAnimation/JackpotWinningAnimation';

export const trackErrorModalMultiplierFailure = (optedIn: number) => {
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_ERROR_MODAL_VIEWED,
    errorType: 'opt_in_multiplier_failure',
    multiplier: optedIn ? `${optedIn}x` : null,
  });
};

export const trackJackpotWin = (
  optedIn: number,
  amount: number,
  tierName: string,
) => {
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_JACKPOT_WIN,
    multiplier: optedIn ? `${optedIn}x` : null,
    optInStatus: `opted_${optedIn ? 'in' : 'out'}`,
    amount,
    tierName,
  });
};

export const trackJackpotsModalToggle = (
  optedInOption: string,
  showTCPopup: boolean,
) => {
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_JACKPOTS_MODAL_TOGGLED,
    showTCPopup,
    optedInOption,
  });
};

export const trackJackpotsModalViewed = (optedInOption: string) => {
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_JACKPOTS_MODAL_VIEWED,
    optedInOption,
  });
};

export const trackJackpotsOptInToggled = (
  optedInOption: string,
  multiplier: number | undefined,
  jackpotTiers: Array<JackpotTier>,
  isDyb: boolean,
) => {
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_JACKPOTS_OPT_IN_TOGGLED,
    optedInOption,
    multiplier: multiplier ? `${multiplier}x` : null,
    isDyb,
    jackpotTiers,
  });
};

export const trackGameScreenMinMax = (
  optedInOption: string,
  isOn: boolean | undefined,
) => {
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_SCREEN_TOGGLED,
    optedInOption,
    isOn,
  });
};

export const trackWinPageCTAClicked = (
  linkText: string,
  optedInOption: string,
  wonJackpotData: WonJackpotData | undefined,
  context?: Record<string, unknown>,
) => {
  if (linkText !== 'spin') {
    Logger.logRumAction({
      name: '[GW][SWJ]jackpots_win_dialog_did_disappear',
      useCase: DdEventCategory.GameContext,
      eventType: DdEventType.Info,
      context,
    });
  }
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_WIN_SCREEN_CTA_CLICKED,
    optedInOption,
    linkText,
    tier: wonJackpotData?.name?.toLowerCase(),
    amount: wonJackpotData?.amount,
  });
};

export const trackWinPageViewed = (
  context: Record<string, unknown>,
  optedInOption: string,
  wonJackpotData: WonJackpotData | undefined,
) => {
  Logger.logRumAction({
    name: '[GW][SWJ]jackpots_win_dialog_did_disappear',
    useCase: DdEventCategory.GameContext,
    eventType: DdEventType.Info,
    context: context,
  });
  trackUserAction({
    event: TRACK_USER_ACTION_EVENT.IN_GAME_WIN_SCREEN_VIEWED,
    optedInOption,
    tier: wonJackpotData?.name?.toLowerCase(),
    amount: wonJackpotData?.amount,
  });
};
